module.exports = __webpack_public_path__ + "img/flag_pt.57d7dd13.svg";